import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged  } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyB_YpMsx5aTIEY3v7HSWUpGTEyqgMnDbRU",
    authDomain: "rockbridge-ios-49669.firebaseapp.com",
    projectId: "rockbridge-ios-49669",
    storageBucket: "rockbridge-ios-49669.appspot.com",
    messagingSenderId: "153311047088",
    appId: "1:153311047088:web:c478b52adb323e124e3a75",
    measurementId: "G-0X2HNTQP3J"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app)
export const db = getFirestore(app);
export const FIREBASE_STORAGE = getStorage(app);

export { onAuthStateChanged };
